$(document).ready(function() {
  $(document).on("click", ".starapps-tooltip", function(){
    $("body").addClass("modal-open");
  	$(".starapps-modal").show();
  });
  
  $(document).on("click", ".starapps-modal-close", function(){
    $("body").removeClass("modal-open");
  	$(".starapps-modal").hide();
  });
  
  $(document).on("click", ".starapps-modal", function(){
    $("body").removeClass("modal-open");
  	$(".starapps-modal").hide();
  });
  
  $(document).on("click", ".starapps-modal-content", function(){
  	event.stopPropagation();
  });

  /* SV-12.04.2021 */
  footerMobile();
  mobileServiceButton();
});

/* SV-12.04.2021 */
function footerMobile() {
  $('.site-footer [data-type="newsletter"] button.collapsible-trigger-btn').click();
}

function addMobileContact() {
  if ($('.hover-contact-mobile').length == 0) {
    $('body').after($('.hover-contact').clone().addClass('hover-contact-mobile'));

    $('.hover-contact-mobile').find('.wrap').append('<div class="close-contact"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"></path></svg></div>');
    
    $('.hover-contact-mobile').before('<div class="overlay"></div>');
  }  
}

function toggleMobileContact() {
  $('.hover-contact-mobile').toggleClass('active');
  $('.overlay').toggleClass('active');
}

function mobileServiceButton() {
  $(document).on('click', '.phone-service-btn', function(e) {
    addMobileContact();
    
    setTimeout(toggleMobileContact, 100);
  });
  
  $(document).on('click', '.close-contact', function(e) {
    toggleMobileContact();    
  });
  
  $(document).on('click', '.overlay', function(e) {
    toggleMobileContact();    
  });  
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ScrollTo', () => ({
    ScrollTo(e) {
      let $target_mob = document.querySelector(e.currentTarget.dataset.target_mob);
      let $target_desk = document.querySelector(e.currentTarget.dataset.target_desk);

      let isMobile = window.matchMedia("(max-width: 768px)").matches;
      let $target = isMobile ? $target_mob : $target_desk;      

      window.scrollTo({
        top: $target.offsetTop,
        behavior: "smooth",
      });
    }
  }));

  Alpine.data('PartialPrice', (price) => ({
    price: price,
    mounted() {
      let am = this;
      document.addEventListener('variantChange', (e) => {
        // console.log(e);
        am.price = e.detail.variant.price;
      });
    },
    GetPartialPrice() {
      let am = this;
      return theme.Currency.formatMoney(am.price / 4, theme.settings.moneyFormat);
    }
  }));

  Alpine.data('SizeInfoModal', (_sizes) => ({
    tabs: [],
    active_tab: '',
    init() {
      let am = this;
      am.InitSelf();
    },
    InitSelf() {
      let $size_modal = document.querySelector('#size-info-modal')
      if (!$size_modal || !_sizes || _sizes.length == 0) return;

      let am = this;
      am.tabs = _sizes

      // let isMobile = window.matchMedia("(max-width: 768px)").matches;

      // preselect first tab
      // if (!isMobile) {
        am.SetActiveTab(am.tabs[0])
      // }

      // move to actual section
      if (!$size_modal.querySelector('[x-data]')) {
        $size_modal.insertAdjacentElement('beforeend', am.$el)
      }
    },
    SetActiveTab(tab) {
      let am = this;
      am.active_tab = tab;
    }
  }));

  const size_filter_id = GetSizeFilterId();
  console.log('Size filter ID:', size_filter_id);
  Alpine.data('GridColorSwatches', () => ({
    product_handle: '',
    size_filter_id: size_filter_id,
    mounted() {
      let am = this
      am.product_handle = am.$el.dataset.product_handle;
      document.addEventListener('load-product-linked-swatches', this.LoadSwatches.bind(this));
    },
    async LoadSwatches() {
      let am = this;
      if (am.$el.classList.contains('loaded')) return;
      let $product_card = am.$el.closest('.grid-product');
      if ($product_card.querySelector('.grid-product__swatches.loaded')) {
        return;
      }
      am.$el.classList.add('loaded');

      let section_id = 'linked-color-swatches'
      let section_url = `/products/${ am.product_handle }/?sections=${ section_id }`
      let res = await fetch(section_url).then(res => res.json())
      let $linked_swatches = ConvertStringToHTML(res[section_id]).querySelector('.shopify-section .swatches-wrap')

      if (!$linked_swatches) return

      $linked_swatches.querySelectorAll('.swatch').forEach(($swatch) => {
        $swatch.removeAttribute(':class');
      });
      $linked_swatches.querySelector('.swatch').classList.add('selected');

      // show + 
      let display_count = 3
      let swatches_count = $linked_swatches.querySelectorAll('.swatch-wrap').length
      let remaining = swatches_count - display_count
      if (remaining > 0) {
        $linked_swatches.insertAdjacentHTML('beforeend', `<span>+ ${ remaining }<span class="desktop-only"> weitere</span></span>`)
      }

      am.$el.insertAdjacentElement('beforeend', $linked_swatches);
    },
    e_SwitchProduct(e) {
      // console.log(e)
      let $target = e.currentTarget
      let $product = $target.closest('.grid-product')

      $product.querySelector('.selected').classList.remove('selected')
      $target.querySelector('.swatch').classList.add('selected')

      // update url
      let $productLink = $product.querySelector('.grid-product__link')
      $productLink.setAttribute('href', $target.getAttribute('href'))

      // update product title
      let $productTitle = $product.querySelector('.grid-product__title')
      $productTitle.innerText = $target.dataset.product_title

      // update main image
      let $img = $product.querySelector('.pfs-main-image') || $product.querySelector('.grid-product__image')
      UpdateImageSrc($img, $target.dataset.product_image_url)

      // update hover image
      let $hover_img = $product.querySelector('.image-wrap img:not(.pfs-main-image)')
      // console.log($hover_img)
      UpdateImageSrc($hover_img, $target.dataset.product_image_hover_url)

      // remove tag badges root / stack / loose badges and re-init with new tags
      let $tagBadgesRoot = $product.querySelector('.product-tag-badges-root')
      if ($tagBadgesRoot) {
        $tagBadgesRoot.remove()
      }
      let $badgeStack = $product.querySelector('.product-badges-stack')
      if ($badgeStack) {
        $badgeStack.remove()
      }
      let $productBadges = $product.querySelectorAll('.product-badge')
      $productBadges.forEach(($badge) => {
        $badge.remove()
      })
      $product.removeAttribute('x-data')
      $product.removeAttribute('x-init')
      $product.removeAttribute('data-product-tags')
      $product.setAttribute('data-product-tags', $target.dataset.product_tags)
      setTimeout(() => {
        $product.setAttribute('x-data', 'ProductBadgeItem')
        $product.setAttribute('x-init', 'mounted')
      })
    }
  }));
  
  Alpine.data('LoadMoreProducts', () => ({
    page: 1,
    page_count: 1,
    delay: 2500,
    flags: {
      loading: false,
      isLastPage: false
    },
    selectors: {
      collection_grid: '.grid--collection',
      product_item: '.grid-product'
    },
    mounted() {
      let am = this;
      am.page_count = parseInt(am.$el.dataset.page_count);

      // preload 2nd page
      am.LoadMore();

      document.body.onscroll = (e) => {
        let scrollReachedBottom = window.scrollY >= (am.$el.scrollHeight - am.$el.offsetTop * 3);

        if (!scrollReachedBottom) return;
        if (am.flags.loading) return;
        if (am.flags.isLastPage) return;

        // console.log(e);
        Alpine.throttle(() => {
          am.flags.loading = true;
          setTimeout(am.LoadMore.bind(am), am.delay);
        }, 500)();
      }
    },

    LoadMore() {
      am = this;

      am.page += 1;
      am.flags.isLastPage = am.page >= am.page_count;

      (async () => {
        let section_id = am.$el.dataset.sectionId;
        let url  = `${ window.location.pathname }?page=${ am.page }&sections=${ section_id }`;
        // console.log(url);
        let res = await fetch(url).then((res => res.json()));
        // console.log(res);
        let $section = ConvertStringToHTML(res[section_id]);
        let $products = [...$section.querySelectorAll(am.selectors.product_item)];
        // console.log($section, $products);

        $products.forEach(($product) => {
          am.$el.querySelector(am.selectors.collection_grid).insertAdjacentElement('beforeend', $product);
        });

        am.$el.dataset.page = am.page;
        am.flags.loading = false;
      })();
    }
  }));

  Alpine.data('MatteOptions', (selected_matte, enablePadOptions) => ({
    selected_matte: selected_matte,
    flags: {
      enablePadOptions: enablePadOptions
    },
    init() {
      let am = this;
      am.UpdateSelectedMatte()
      am.$watch('selected_matte', am.UpdateSelectedMatte.bind(am))
    },
    e_ToggleStandardPad(e) {
      // console.log(e, e.target, e.currentTarget)
      let am = this;
      let $no_pad = e.currentTarget.querySelector('.matte-checkbox')
      if (am.selected_matte !== $no_pad.value) {
        am.selected_matte = $no_pad.value
      }
      else {
        let $productForm = am.$el.closest('.product-single__form')
        let $firstInputMain = $productForm.querySelector('.variant__input-main[data-index=option2]:first-of-type')
        am.selected_matte = $firstInputMain.value
      }
    },
    UpdateSelectedMatte() {
      let am = this;
      let $productForm = am.$el.closest('.product-single__form')

      if (am.flags.enablePadOptions) {
        let $matte_radio = am.$el.querySelector(`input[value="${ am.selected_matte }"]`)
        if (!$matte_radio) return;

        let valueHandle = $matte_radio.dataset.valueHandle
        am.$nextTick(() => {
          let $mainInput = $productForm.querySelector(`.variant__input-main[data-value-handle="${ valueHandle}"]`)
          $mainInput.checked = true
          $mainInput.dispatchEvent(new CustomEvent('change', { bubbles: true }))
        })
      }
      else {
        am.$nextTick(() => {
          let $no_pad = $productForm.querySelector('.no-matte')
          let valueHandle = $no_pad.dataset.valueHandle

          $no_pad.checked = am.selected_matte == $no_pad.value
          $no_pad.dispatchEvent(new CustomEvent('change', { bubbles: true }))

          let $mainInput = $productForm.querySelector(`.variant__input-main[data-value-handle="${ valueHandle}"]`)
          if (am.selected_matte !== $no_pad.value) {
            let $firstInputMain = $productForm.querySelector('.variant__input-main[data-index=option2]:first-of-type')
            $mainInput = $firstInputMain
          }
          $mainInput.checked = true
          $mainInput.dispatchEvent(new CustomEvent('change', { bubbles: true }))
        })
      }      
    }
  }));

  Alpine.data('CalendarPopup', () => ({
    $product: null,
    $calendarPopup: null,
    mounted() {
      let am = this;
      am.$product = am.$el.closest('.product-single__meta')
      am.$calendarPopup = $(am.$product.querySelector('#addToCalendarPopup'))
    },
    e_OpenPopup() {
      let am = this;
      am.$calendarPopup.show()
      $("html").addClass("no-srcoll")
    },
    e_ClosePopup() {
      let am = this;
      am.$calendarPopup.hide()
      $("html").removeClass("no-srcoll");
    },
    e_CheckOverlayClick(e) {
      // console.log(e)
      let am = this;
      if (!e.target.closest('.modal-content')) {
        am.e_ClosePopup()
      }
    }    
  }));

  Alpine.data('ShippingCost', () => ({
    Shop_country: Shopify.country ?? 'DE',
  }));

  const CheckVariantsOnSale = (e) => {
    // console.log(window.current_product, e.detail);
    if (!window.current_product) return;
    let selected_variant = current_product.selected_variant
    if (e.detail && e.detail.variant) {
      selected_variant = e.detail.variant
    }
    // console.log(selected_variant.options)
    let option2 = selected_variant.option2
    let variants_on_sale = current_product.variants.filter((v) => {
      return v.option2 == option2 && v.sale_price
    })

    let $form = document.querySelector(`#AddToCartForm-${current_product.id}`)
    let sale_active_class = 'sale-active'

    // console.log($form.querySelectorAll(`.${sale_active_class}`))
    $form.querySelectorAll(`.${sale_active_class}`).forEach(($sale) => {
      $sale.classList.remove(sale_active_class)
    })
    variants_on_sale.forEach((v) => {
      let $size = $form.querySelector(`.size-sale-badge[data-size="${v.option1}"]`)
      if (!$size) return
      $size.classList.add(sale_active_class)
    })
  }

  if (theme.settings.enable_variants_sale) {
    document.addEventListener('variantChange', CheckVariantsOnSale);
    document.addEventListener('check-variant-sale', CheckVariantsOnSale);
  }

  Alpine.data('CollectionTile', () => ({
    MQ_list: {
      MQ_1: window.matchMedia("(min-width: 425px)"),
      MQ_2: window.matchMedia("(min-width: 600px)"),
      MQ_3: window.matchMedia("(min-width: 900px)")
    },
    init() {
      let am = this;
      let $tile_node = document.querySelector(`[data-collection-tile="${am.$el.dataset.index}"]`);
      if (!$tile_node) return;
      let $tile = $tile_node.cloneNode(true);
      // console.log(am.$el, am.$el.dataset.index, $tile);

      am.$el.classList.add(...[...$tile.classList]);
      am.$el.insertAdjacentHTML('beforeend', $tile.innerHTML);

      am.SetTileHeight();
      for (let [key, MQ] of Object.entries(am.MQ_list)) {
        MQ.addEventListener('change', am.SetTileHeight.bind(am));
      }
    },
    SetTileHeight() {
      let am = this;
      let $nearestItem = am.$el.previousSibling;
      if (!$nearestItem) return;
      let $nearestImgWrap = $nearestItem.querySelector('.grid-product__image-mask');
      am.$el.style.height = `${$nearestImgWrap.offsetHeight}px`;
    }
  }));

  Alpine.data('Main', () => ({
    template: '',
    delay: 2500,
    flags: {
      pageLoadingComplete: false,
      isCollectionPage: false,
      isProductPage: false
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.pageLoadingComplete', () => {
        document.querySelector('.main-content').classList.toggle('is-loading', !am.flags.pageLoadingComplete);
      });
    },
    InitSelf() {
      let am = this;
      am.template = am.$el.dataset.template;
      am.UpdateFlags();

      if (am.flags.isCollectionPage || am.flags.isProductPage) {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            am.flags.pageLoadingComplete = true;
          }, am.delay);
        });
      }
      else {
        am.flags.pageLoadingComplete = true;
      }

      // Move header menu drawer outside section-header
      let $section_header = document.querySelector('.section-header-container');
      if ($section_header.classList.contains('sticky-header')) {
        let $headerMenuDrawer = document.querySelector('#NavDrawer');
        if ($headerMenuDrawer) {
          document.querySelector('#shopify-section-header').insertAdjacentElement('afterend', $headerMenuDrawer);
        }
        setTimeout(am.SetRootHeaderAttributes.bind(this), 0);
        window.addEventListener('resize', Alpine.debounce(am.SetRootHeaderAttributes.bind(this), 100));
        document.body.classList.add('has-sticky-header');
      }

      if (document.querySelector('.site-navigation')) {
        ObserveMutation(document.querySelector('.site-navigation'), { childList: true }, (mutations) => {
          [...document.querySelectorAll('.tmenu_item')].forEach($mega => {
            ObserveMutation($mega, { 
              childList: true,
              attributes : true,
              attributeFilter : ['style', 'class']              
            }, (mutations) => {
              // console.log(mutations);
              document.dispatchEvent(new CustomEvent('search:close'));
            });
          });
        });
      }
    },
    UpdateFlags() {
      let am = this;
      am.flags.isCollectionPage = am.template.indexOf('collection.') !== -1;
      am.flags.isProductPage = am.template.indexOf('product.') !== -1;
    },
    SetRootHeaderAttributes() {
      let $announcement = document.querySelector('.announcement-bar');
      if ($announcement) {
        document.documentElement.style.setProperty('--announcement-height', `${$announcement.offsetHeight}px`);
      }

      let $header = document.querySelector('.site-header');
      if ($header) {
        document.documentElement.style.setProperty('--header-height', `${$header.getBoundingClientRect().height}px`);
      }
    }
  }));

  const SESSION_CART_DISCOUNT_PROMO_CLICKED = 'cart_discount_promo_clicked';
  Alpine.data('ApplyDiscountCode', () => ({
    d_code: '',
    cart_discount_promo_clicked: localStorage.getItem(SESSION_CART_DISCOUNT_PROMO_CLICKED) == 'true',
    flags: {
      discountApplied: false,
      hideBuy2Save: false
    },
    init() {
      let am = this;
      am.d_code = am.$el.dataset.d_code;
      if (am.cart_discount_promo_clicked) {
        am.flags.discountApplied = true;
        am.$el.classList.add('hidden');
      }

      document.addEventListener('store:cart:updated', am.CheckIfDiscountCodeApplied.bind(am));
    },
    CheckIfDiscountCodeApplied() {
      let cart = Alpine.store('cart').cart;
      this.flags.discountApplied = cart.discount_codes.filter(item => item.code == this.d_code).length !== 0;
      this.flags.hideBuy2Save = cart.item_count >= 2;
      this.$el.removeAttribute('x-cloak-hide');
    },
    async e_ApplyDiscount(e) {
      let am = this;

      // remove banner as soon as clicked
      am.$el.classList.add('hidden');
      localStorage.setItem(SESSION_CART_DISCOUNT_PROMO_CLICKED, true);

      let d_code = e.currentTarget.dataset.d_code;
      let res_cart_with_discount = await UpdateCartDiscountCode(d_code);
      // console.log(res_cart_with_discount);

      // remove banner after code applied
      am.flags.discountApplied = true;
      document.dispatchEvent(new CustomEvent('added.ajaxProduct'));
    }
  }));

  Alpine.data('CartDiscountMessage', () => ({ 
    discount_code: '',
    cart_discount_promo_clicked: localStorage.getItem(SESSION_CART_DISCOUNT_PROMO_CLICKED) == 'true',
    flags: {
      is_buy2save: false,
      showSuccessMessage: false,
      showPromptMessage: false,
      showSprayMessage: false
    },
    messages: {
      success: '',
      prompt: ''
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.flags.is_buy2save = this.$el.dataset.type == 'buy2save';
      this.discount_code = this.$el.dataset.discount_code;
      this.messages.success = this.$el.dataset.success_message;
      this.messages.prompt = this.$el.dataset.prompt_message;

      this.CheckCartDiscount();
      this.UpdateMessage();
      this.CheckCartUpsell();
      document.addEventListener('store:cart:updated', this.CheckCartDiscount.bind(this));
      document.addEventListener('store:cart:updated', this.CheckCartUpsell.bind(this));
      this.$el.removeAttribute('x-cloak-hide');      
    },
    InitWatchers() {
      this.$watch('flags.showPromptMessage', this.UpdateMessage.bind(this));
    },
    CheckCartDiscount() {
      let cart = Alpine.store('cart').cart;
      if (!cart || cart.discount_codes.length == 0) return;

      let is_discount_active = cart.discount_codes.filter(item => item.code === this.discount_code).length > 0;
      if (this.flags.is_buy2save) {
        this.flags.showPromptMessage = cart.item_count < 2 && is_discount_active;
        // console.log(this.flags.showPromptMessage);
      }
      let is_discount_applied = cart.discount_codes.filter(item => item.code === this.discount_code && item.applicable).length > 0;
      this.flags.showSuccessMessage = is_discount_applied;
    },
    UpdateMessage() {
      if (this.$el.classList.contains('cart-upsell-disabled-message')) return;
      this.$el.textContent = this.flags.showPromptMessage ? this.messages.prompt : this.messages.success;
    },
    CheckCartUpsell() {
      let cart = Alpine.store('cart').cart;
      let upsell_handle = this.$el.dataset.upsellHandle;
      if (!upsell_handle) return;

      let cart_upsell_item = cart.items.find(item => item.handle === upsell_handle);
      let is_allowed = !(cart.items.length == 1 && cart_upsell_item !== undefined);
      // console.log({cart_upsell_item, is_allowed});
      this.flags.showSprayMessage = !is_allowed;

      let $cart_drawer = this.$el.closest('#CartDrawer');
      $cart_drawer.classList.toggle('cart-upsell-disabled', this.flags.showSprayMessage);
    }
  }));

  Alpine.store('cart', {
    cart: {
      item_count: 0,
      cart_level_discount_applications: [],
      items: [],
      discount_codes: []
    },
    async init() {
      // Load initial cart data
      this.UpdateCart();

      // when cart updated, update store cart
      $('body').on('updateCart.ajaxcart', Alpine.debounce((e) => {
        this.UpdateCart();
      }, 250));

      // when item added to cart, update store cart
      document.addEventListener('added.ajaxProduct', this.UpdateCart.bind(this));
    },
    async UpdateCart() {
      let cart = await GetCartJS();
      this.cart = {...cart};
      document.dispatchEvent(new CustomEvent('store:cart:updated'));
    }
  });

  Alpine.data('StickyAddToCart', () => ({
    cache: {},
    init() {
      let am = this;
      am.InitSelf();
      am.CheckSticky();
    },
    InitSelf() {
      let am = this;
      am.cache.$form = document.querySelector(am.$el.dataset.form_id);
      am.cache.$target = am.cache.$form.querySelector('.add-to-cart:not(.add-to-cart--sticky)');
    },
    CheckSticky() {
      let am = this;
      if (!am.cache.$target) return;

      let $sticky = am.$el;

      ObserveIntersection(am.cache.$target, {}, (entries) => {
        let entry = entries[0];
        let isSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;

        $sticky.classList.toggle('is-sticky', isSticky);

        let $chat_btn = document.querySelector('#tidio-chat-iframe');
        if ($chat_btn) {
          $chat_btn.style.bottom = isSticky ? '60px' : '15px';
        }
      });
    },
    e_AddToCart() {
      let am = this;
      am.cache.$form.dispatchEvent(new CustomEvent('submit'));
    }
  }));

  Alpine.data('HeaderSearch', () => ({
    query: '',
    keywords: ['Persisch Smaragd', 'Matte', 'Neue Designs', 'Uno Taupe'],
    results_products: [],
    results_collections: [],
    flags: {
      api_called: false
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
    },
    InitSelf() {
      this.keywords = JSON.parse(this.$el.dataset.search_keywords);
    },
    InitWatchers() {
      this.$watch('query', this.LoadBoostSearchResults.bind(this));
    },
    async LoadBoostSearchResults() {
      let shop = Shopify.shop || 'teppani.com.myshopify.com';
      let t = new Date().getTime();
      let search_url = `//services.mybcapps.com/bc-sf-filter/search/suggest?q=${this.query}&shop=${shop}&t=${t}&product_available=true&product_limit=4&event_type=suggest`;
      let res = await fetch(search_url).then(res => res.json());
      this.flags.api_called = true;
      // console.log(res);
      this.results_products = [...res.products];
      this.results_collections = [...res.collections];
    }
  }));

  Alpine.data('CartUpsellItem', () => ({
    upsell_variant_id: '',
    flags: {
      show: false
    },
    init() {
      this.upsell_variant_id = this.$el.dataset.upsell_variant_id;
      this.InitWatchers();
      this.UpdateFlags();
    },
    InitWatchers() {
      document.addEventListener('store:cart:updated', this.UpdateFlags.bind(this));
    },
    UpdateFlags() {
      let am = this;
      am.flags.show = Alpine.store('cart').cart.items.filter(item => item.id == am.upsell_variant_id).length == 0;
    }
  }));

  Alpine.data('QuickAddVariant', () => ({
    async e_QuickAdd(e) {
      // console.log(e);
      let add_variant_id = this.$el.dataset.add_variant_id;
      if (!add_variant_id) return;
      let item_to_add = {
        id: add_variant_id,
        quantity: 1
      };

      let qty_limit = e.currentTarget.dataset.qty_limit;
      if (qty_limit) {
        item_to_add.properties = {
          '_qty_limit': qty_limit
        }
      }
      let res = await AddItemsToCart([item_to_add]);
      // refresh cart
      document.dispatchEvent(new CustomEvent('added.ajaxProduct'));
      setTimeout(() => {
        // scroll to top of cart
        document.querySelectorAll('.drawer--has-fixed-footer .drawer__inner').forEach(($inner) => {
          $inner.scrollTo(0,0);
        });
      }, 1000);
    }
  }));

  Alpine.data('CartFooter', () => ({
    cache: {},
    init() {
      this.InitSelf();
    },
    InitSelf() {
      this.cache.$cart = this.$el.closest('#CartDrawer');
      this.cache.$cart_form = this.cache.$cart.querySelector('.ajaxcart');
      this.cache.$cross_sells = this.cache.$cart.querySelector('.cart-cross-sells'); 
      if (this.cache.$cross_sells) {
        this.cache.$cart.style.setProperty('--cross-sells-height', `${this.cache.$cross_sells.offsetHeight * 0.7}px`);
      }
    },
    e_ShowFooter(e) {
      let is_mobile = window.matchMedia("(max-width: 768px)").matches;
      if (is_mobile) return;
      this.cache.$cart_form.classList.add('expanded');
    },
    e_HideFooter(e) {
      let is_mobile = window.matchMedia("(max-width: 768px)").matches;
      if (is_mobile) return;
      this.cache.$cart_form.classList.remove('expanded');      
    },
    e_ToggleFooter(e) { 
      let is_mobile = window.matchMedia("(max-width: 768px)").matches;
      if (!is_mobile) return;
      let $cart_form = this.cache.$cart_form;
      if ($cart_form.classList.contains('expanded')) {
        $cart_form.classList.remove('expanded');
      }
      else {
        $cart_form.classList.add('expanded');
      }
    }
  }));

  Alpine.data('CopyCode', () => ({
    copied: false,
    e_CopyCode(event) {
      const code = event.currentTarget.dataset.code;
      if (!code) return;
      navigator.clipboard.writeText(code).then(() => {
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      });
    }
  }));

  Alpine.data('SaleCountdown', () => ({
    timeLeft: 0,
    init() {
      this.$nextTick(this.InitSelf.bind(this));
    },
    InitSelf() {
      let $pf_countdowns = [...document.querySelectorAll('[data-pf-type="CountDown"]')];
      // console.log($pf_countdowns);
      if (!$pf_countdowns.length) return;

      $pf_countdowns.forEach(($pf_countdown) => {
        ObserveMutation($pf_countdown, { childList: true, subtree: true }, (m) => {
          // console.log(m)
          let $countdown = $pf_countdowns.find($item => $item.style.display !== 'none');
          if (!$countdown) return;
          this.$el.innerHTML = $countdown.outerHTML;
        });
      });
    }
  }));

  Alpine.data('ProductSavedAmount', () => ({
    current_variant: null,
    display_type: 'amount', // amount or percent
    saved_amount: 0,
    saved_percent: 0,
    init() {
      this.InitWatchers();
      this.display_type = this.$el.dataset.display_type || 'amount';
      this.current_variant = window.current_product ? window.current_product.selected_variant : null;
    },
    InitWatchers() {
      document.addEventListener('trigger-variant-price-change', (e) => {
        if (!window.current_product) return;
        if (this.current_variant?.id == window.current_product.selected_variant?.id) return;
        this.current_variant = window.current_product.selected_variant;
      });

      document.addEventListener('variantChange', (e) => {
        if (!window.current_product) return;
        if (this.current_variant?.id == window.current_product.selected_variant?.id) return;
        this.current_variant = window.current_product.selected_variant;
      });

      this.$watch('current_variant', this.UpdateSavedAmount.bind(this));
    },
    UpdateSavedAmount() {
      // console.log(this.current_variant);
      let variant = this.current_variant;
      let compare_at_price = variant.compare_at_price || variant.price;
      let price = variant.price;

      if (theme.settings.enable_variants_sale && variant.sale_price) {
        compare_at_price = variant.price;
        price = variant.sale_price;
      }

      let saved_amount = compare_at_price > price ? compare_at_price - price : 0;
      let saved_percent = saved_amount > 0 ? (saved_amount / compare_at_price * 100) : 0;
      saved_percent = Math.round(saved_percent).toFixed(2).replace('.00', '');

      this.saved_amount = saved_amount;
      this.saved_percent = saved_percent;
    },
    u_FormatMoney(amount) {
      return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }
  }));

  // test url - ?collection=neue-designs&pf_opt_gre=%C3%B8+120cm+rund
  Alpine.data('CollectionFeed', () => ({
    collection_url: '',
    collection_handle: '',
    collection_json: {},
    api_client_id: '9e8646a3-d9f9-434b-8716-22dc8ec75b70',
    api_response: {},
    size_filter_id: size_filter_id || 'pf_opt_taille',
    page: 1,
    filters: {},
    products: [],
    tile_positions: [6, 14, 22, 30, 38, 46],
    init() {
      this.InitSelf();
    },
    async InitSelf() {
      let url_params = new URLSearchParams(window.location.search || this.collection_url);
      let collection_url = url_params.toString();
      if (!url_params.has('collection')) return;

      this.collection_handle = url_params.get('collection');
      this.collection_url = `?collection=${collection_url}`;

      let filters_json = {};
      url_params.keys().forEach(key => {
        if (key.includes('pf_')) {
          let values = url_params.getAll(key);
          filters_json[key] = values;
        }
      });
      this.filters = filters_json;     
      document.body.classList.add('has-collection-feed')
      this.$el.classList.remove('visually-hidden');

      // load first page
      await this.LoadProducts(1);

      let $paginate = this.$el.querySelector('.pagination');
      if ($paginate) {
        // watch intersection
        ObserveIntersection($paginate, {}, async (entries) => {
          let current_page = this.page;
          let total_pages = Math.ceil(this.api_response.total_product / 24);
          let entry = entries[0];
          if (entry.isIntersecting && current_page > 1 && current_page <= total_pages) {
            let next_page = current_page + 1;
            if (next_page <= total_pages) {
              await this.LoadProducts(next_page);
            }
          }
        });
      }
    },
    async LoadProducts(page = 1) {
      let handle = this.collection_handle;
      let url_json = `/collections/${handle}.json`;
      let collection_json = await fetch(url_json).then(res => res.json());
      this.collection_json = collection_json;
      let filters = this.filters;
      let filters_url = '';
      // convert filters to url params as []
      for (let [key, values] of Object.entries(filters)) {
        for (value of values) {
          filters_url += `&${key}[]=${value}`;
        }
      }
      filters_url = encodeURI(filters_url);

      let api_url = `https://services.mybcapps.com/bc-sf-filter/filter?t=${Date.now()}${filters_url}&_=pf&shop=${Shopify.shop}&page=${page}&limit=24&display=grid&collection_scope=${collection_json.collection.id}&tag=&product_available=false&variant_available=false&build_filter_tree=true&check_cache=false&sid=${this.api_client_id}`;
      
      let size = this.filters.hasOwnProperty(this.size_filter_id) ? this.filters[this.size_filter_id][0] : '';
      let res = await fetch(api_url).then(res => res.json());
      this.api_response = res;
      this.page = this.page + 1; 

      let products = res.products.map((p) => {
        let variant = p.variants[0], matched_variant = variant;
        let img_index = 0;
        let img_hover_index = 3;
        if (this.filters[this.size_filter_id]) {
          // select the last item
          matched_variant = p.variants.find((v) => v.merged_options.join(',').includes(size));
          if (!matched_variant) {
            matched_variant = variant;
          }
          img_index = p.images_info.findIndex(img => img.src == matched_variant.image);
          img_hover_index = img_index + 3;
          if (img_hover_index >= p.images_info.length) {
            img_hover_index = 3;
          }
        }

        p.default_variant = matched_variant.id == variant.id;

        if (theme.settings.enable_pdp_discount) {            
          [1,2,3].forEach((i) => {
            let discount_id = `pdp_discount_${i}`;
            let tag = theme.settings[discount_id][0];
            let percent = theme.settings[discount_id][1];
            if (p.tags.includes(tag)) {
              let price = parseFloat(matched_variant.price);
              let price_off = price * (percent / 100);
              let sale_price = price - price_off;
              // console.log(matched_variant.price, price_off);
              matched_variant.compare_at_price = price * 100;
              matched_variant.price = sale_price * 100;
            }
          });
        }

        p.matched_variant = matched_variant;
        p.img_index = img_index;
        p.img_hover_index = img_hover_index;
        p.grid_color_swatches = `
          <div class="grid-product__swatches"
            data-product_handle="${p.handle}"
            x-data="GridColorSwatches" x-init="mounted">
          </div>
        `;
        return p;
      });

      this.products = [...this.products, ...products];
      this.$nextTick(() => {
        document.dispatchEvent(new CustomEvent('load-product-linked-swatches'));
      });

      // insert collection tiles only on first page load
      if (page == 1) {
        let res_tiles = await fetch(`/collections/${collection_json.collection.handle}?section_id=collection-tiles`).then(res => res.text());
        let $tiles_section = ConvertStringToHTML(res_tiles).querySelector('.shopify-section');
        this.$el.insertAdjacentElement('afterend', $tiles_section);
      }

      this.$nextTick(() => {
        let positions = this.tile_positions;
        let $tiles = document.querySelectorAll('.hidden-tiles [data-collection-tile]');
        $tiles.forEach(($tile, index) => {
          let pos = positions[index];
          $tile.dataset.position = pos;
        });

        [...$tiles].filter($tile => !$tile.classList.contains('tile-added')).forEach(($tile) => {
          let pos = $tile.dataset.position;
          let $insert_before = this.$el.querySelector(`.grid-product[data-index="${pos}"]`);
          if ($insert_before) {
            $insert_before.insertAdjacentHTML('afterend', `<div x-data="CollectionTile" data-index="${$tile.dataset.collectionTile}"></div>`);
            $tile.classList.add('tile-added');
          }
        });
      });
    },
    u_FormatMoney(amount) {
      return theme.Currency.formatMoney(amount, theme.settings.moneyFormat);
    }
  }));

  Alpine.data('SectionPfsImageSwatches', () => ({
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      // console.log(this.collection_json);
    },
    InitWatchers() {
      this.$watch('collection_json', this.LoadSection.bind(this));
    },
    async LoadSection() {
      let res = await fetch(`/collections/${this.collection_json.collection.handle}?section_id=pfs-image-swatches`).then(res => res.text());
      this.$el.innerHTML = res;
      this.InitSwiper();
    },
    InitSwiper() {
      var swiper = new Swiper(this.$el.querySelector('.swiper'), {
        // Default parameters
        slidesPerView: 1,
        spaceBetween: 10,
        slidesPerGroup: 1,
        speed: 500,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 15
          },
          // when window width is >= 480px
          768: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 20
          },
          920: {
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: 30
          },
          // when window width is >= 640px
          1200: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: this.$el.querySelector('.swiper-button-next'),
          prevEl: this.$el.querySelector('.swiper-button-prev'),
        }
      });
    }
  }));

  function u_FisherYatesShuffle(items) {
    const arr = [...items];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  function u_IsSaleRandomOrderEnabled($root) {
    return $root && $root.dataset.svRandomOrder === 'true';
  }

  function u_ShuffleGridProducts($grid, $items) {
    if (!$grid) return;

    const $nodes = $items || [...$grid.querySelectorAll(':scope > .grid-product')];
    const $tiles = $nodes.filter(($el) => $el.classList.contains('image-video-item'));
    const $products = $nodes.filter(($el) => !$el.classList.contains('image-video-item'));

    u_FisherYatesShuffle($products).forEach(($el) => {
      $grid.appendChild($el);
    });

    // Keep content inserts fixed after the 7th / 15th / 23rd product cards
    if (!$items && $tiles.length) {
      const insert_after_counts = [7, 15, 23];
      $tiles.forEach(($tile, index) => {
        const after_count = insert_after_counts[index];
        const $product_nodes = [...$grid.querySelectorAll(':scope > .grid-product:not(.image-video-item)')];
        const $anchor = after_count ? $product_nodes[after_count - 1] : null;
        if ($anchor) {
          $anchor.insertAdjacentElement('afterend', $tile);
        } else {
          $grid.appendChild($tile);
        }
      });
    }
  }

  const FILE_URL_PREFIX = "\/\/teppani.com\/cdn\/shop\/t\/13\/assets\/";
  Alpine.data('CollectionTemplate', () => ({
    FILE_URL_PREFIX: FILE_URL_PREFIX,
    collection_handle: '',
    currentPage: 1,
    totalPages: 1,
    infiniteScrollObserver: null,
    flags: {
      loadingMore: false,
      hasMore: false,
      loadError: false,
      scrollToGridOnFilter: false
    },
    filters_drawer: null,
    filterApplyDebounced: null,
    filterSync: null,
    drawer_element: null,
    drawer_opener_element: null,
    drawer_focus_observer: null,
    filters_options: [
      {
        type: 'size',
        id: 'pf_opt_taille',
        name: 'Taille',
        open: false,
        param_name: 'filter.v.option.taille',
        values: [
          {
            id: "50x80cm",
            name: "50 x 80cm",
            value: "50 X 80cm",
            icon_file: '50x80cm.png',
            selected: false,
            value_url: '50+x+80cm'
          },
          {
            id: "80x200cm",
            name: "80 x 200cm",
            value: "80 X 200cm",
            icon_file: '80x200cm.png',
            selected: false,
            value_url: '80+x+200cm'
          },
          {
            id: "80x250cm",
            name: "80 x 250cm",
            value: "80 X 250cm",
            icon_file: '80x250cm.png',
            selected: false,
            value_url: '80+x+250cm'
          },
          {
            id: "80x300cm",
            name: "80 x 300cm",
            value: "80 X 300cm",
            icon_file: '80x200cm.png',
            selected: false,
            value_url: '80+x+300cm'
          },
          {
            id: "90x160cm",
            name: "90 x 160cm",
            value: "90 X 160cm",
            icon_file: '90x160cm.png',
            selected: false,
            value_url: '90+x+160cm'
          },
          {
            id: "120x180cm",
            name: "120 x 180cm",
            value: "120 X 180cm",
            icon_file: '90x160cm.png',
            selected: false,
            value_url: '120+x+180cm'
          },
          {
            id: "140x200cm",
            name: "140 x 200cm",
            value: "140 X 200cm",
            icon_file: '140x200cm.png',
            selected: false,
            value_url: '140+x+200cm'
          },
          {
            id: "170x240cm",
            name: "170 x 240cm",
            value: "170 X 240cm",
            icon_file: '170x240cm.png',
            selected: false,
            value_url: '170+x+240cm'
          },
          {
            id: "200x200cm",
            name: "200 x 200cm",
            value: "200 X 200cm",
            icon_file: '200_Quadrat.png',
            selected: false,
            value_url: '200+x+200cm'
          },
          {
            id: "200x300cm",
            name: "200 x 300cm",
            value: "200 X 300cm",
            icon_file: '200x300cm.png',
            selected: false,
            value_url: '200+x+300cm'
          },
          {
            id: "250x250cm",
            name: "250 x 250cm",
            value: "250 X 250cm",
            icon_file: '200_Quadrat.png',
            selected: false,
            value_url: '250+x+250cm'
          },
          {
            id: "250x300cm",
            name: "250 x 300cm",
            value: "250 X 300cm",
            icon_file: '250x300.png',
            selected: false,
            value_url: '250+x+300cm'
          },
          {
            id: "250x350cm",
            name: "250 x 350cm",
            value: "250 X 350cm",
            icon_file: '250x350.png',
            selected: false,
            value_url: '250+x+350cm'
          },
          {
            id: "120cm-rond",
            name: "Ø 120cm Rond",
            value: "Ø 120cm Rond",
            icon_file: '120_Rund.png',
            selected: false,
            value_url: '%C3%B8+120cm+rond'
          },
          {
            id: "200cm-rond",
            name: "Ø 200cm Rond",
            value: "Ø 200cm Rond",
            value_handle: "o-200cm-rond",
            icon_file: '200cmrund.png',
            selected: false,
            value_url: '%C3%B8+200cm+rond'
          }
        ]
      },
      {
        type: 'color',
        id: 'pf_t_couleur',
        name: 'Couleur',
        open: false,
        param_name: 'filter.p.tag',
        values: [
          {
            id: 'gray-silver',
            name: 'Gris-Argent',
            value: 'Gris-Argent',
            icon_file: 'Filter_Farben_Grau_Silber.svg',
            selected: false,
            value_url: 'Gris-Argent'
          },
          {
            id: 'beige-nature',
            name: 'Beige-Nature',
            value: 'Beige-Nature',
            icon_file: 'Filter_Farben_Beige_Natur.svg',
            selected: false,
            value_url: 'Beige-Nature'
          },
          {
            id: 'blue',
            name: 'Bleu',
            value: 'Bleu',
            icon_file: 'Filter_Farben_Blau.svg',
            selected: false,
            value_url: 'Bleu'
          },
          {
            id: 'green',
            name: 'Vert',
            value: 'Vert',
            icon_file: 'Filter_Farben_Gruen.svg',
            selected: false,
            value_url: 'Vert'
          },
          {
            id: 'red',
            name: 'Rouge',
            value: 'Rouge',
            icon_file: 'Filter_Farben_Rot.svg',
            selected: false,
            value_url: 'Rouge'
          },
          {
            id: 'rose',
            name: 'Rose-Violet',
            value: 'Rose-Violet',
            icon_file: 'Filter_Farben_Rosa_Violett.svg',
            selected: false,
            value_url: 'Rose-Violet'
          },
          {
            id: 'orange',
            name: 'Jaune-Orange',
            value: 'Jaune-Orange',
            icon_file: 'Filter_Farben_Gelb_Orange.svg',
            selected: false,
            value_url: 'Jaune-Orange'
          },
          {
            id: 'brown',
            name: 'Marron-Taupe',
            value: 'Marron-Taupe',
            icon_file: 'Filter_Farben_Braun_Taupe.svg',
            selected: false,
            value_url: 'Marron-Taupe'
          },
          {
            id: 'pattern',
            name: 'Noir-Blanc',
            value: 'Noir-Blanc',
            icon_file: 'Filter_Farben_Schwarz_Weiss.svg',
            selected: false,
            value_url: 'Noir-Blanc'
          },
          {
            id: 'marble',
            name: 'Multicolore',
            value: 'Multicolore',
            icon_file: 'Filter_Farben_Mehrfarbig.svg',
            selected: false,
            value_url: 'Multicolore'
          }
        ]
      },
      {
        type: 'style',
        id: 'pf_t_style',
        name: 'Style',
        open: false,
        param_name: 'filter.p.tag',
        values: [
          {
            id: 'modern',
            name: 'Moderne',
            value: 'Moderne',
            icon_file: 'icon_modern.png',
            selected: false,
            value_url: 'Moderne'
          },
          {
            id: 'classic',
            name: 'Classique',
            value: 'Classique',
            icon_file: 'icon_klassisch.png',
            selected: false,
            value_url: 'Classique'
          },
          {
            id: 'vintage',
            name: 'Vintage',
            value: 'Vintage',
            icon_file: 'icon_vintage.png',
            selected: false,
            value_url: 'Vintage'
          },
          {
            id: 'boho',
            name: 'Boho',
            value: 'Boho',
            icon_file: 'icon_boho.png',
            selected: false,
            value_url: 'Boho'
          },
          {
            id: 'contemporain',
            name: 'Contemporain',
            value: 'Contemporain',
            icon_file: 'icon_zeitgenoessisch.png',
            selected: false,
            value_url: 'Contemporain'
          },
          {
            id: 'persan',
            name: 'Persan',
            value: 'Persan',
            icon_file: 'icon_persisch.png',
            selected: false,
            value_url: 'Persan'
          },
          {
            id: 'scandinave',
            name: 'Scandinave',
            value: 'Scandinave',
            icon_file: 'icon_skandinavisch.png',
            selected: false,
            value_url: 'Scandinave'
          },
          {
            id: 'geometrique',
            name: 'Géométrique',
            value: 'Géométrique',
            icon_file: 'icon_geometrisch.png',
            selected: false,
            value_url: 'Géométrique'
          },
          {
            id: 'marocain',
            name: 'Marocain',
            value: 'Marocain',
            icon_file: 'icon_marokkanisch.png',
            selected: false,
            value_url: 'Marocain'
          },
          {
            id: 'enfants',
            name: 'Enfants',
            value: 'Enfants',
            icon_file: 'icon_kinder.png',
            selected: false,
            value_url: 'Enfants'
          }
        ]
      },
      {
        type: 'texture',
        id: 'pf_t_texture',
        name: 'Texture',
        open: false,
        param_name: 'filter.p.tag',
        values: [
          {
            id: 'indoor',
            name: 'Indoor',
            value: 'Indoor',
            icon_file: 'Indoor_Textur.png',
            selected: false,
            value_url: 'Indoor'
          },
          {
            id: 'moelleux',
            name: 'Moelleux',
            value: 'Moelleux',
            icon_file: 'Flausch_Textur.png',
            selected: false,
            value_url: 'Moelleux'
          },
          {
            id: 'tapis-de-bain',
            name: 'Tapis De Bain',
            value: 'Tapis De Bain',
            icon_file: 'Badematte_Textur.svg',
            selected: false,
            value_url: 'Tapis De Bain'
          }
        ]
      },
      {
        type: 'produkt',
        id: 'pf_t_produit',
        name: 'Produit',
        open: false,
        param_name: 'filter.p.tag',
        values: [
          {
            id: 'salle-de-bain',
            name: 'Salle De Bain',
            value: 'Salle De Bain',
            icon_file: 'Filter_Badezimmer.svg',
            selected: false,
            value_url: 'Salle De Bain'
          }
        ]
      }

    ],
    selectedKeysSnapshot: '',
    current_selected_values: [],
    get selected_values() {
      if (!this.filters_options) return [];
      let selected_values = [];
      [...this.filters_options].forEach(option => {
        option.values.forEach(value => {
          if (value.selected) {
            value.param_name = option.param_name;
            value.option_id = option.id;
            selected_values.push(value);
          }
        });
      });
      return selected_values;
    },
    u_GetSelectedValuesByOption(option_id) {
      if (!this.filters_options) return [];
      return [...this.filters_options.find(option => option.id == option_id).values].filter(value => value.selected);
    },
    u_NormalizeQueryValues(values) {
      const raw_values = Array.isArray(values) ? values : [values];
      return [...new Set(
        raw_values
          .map(value => typeof value === 'string' ? value.trim() : '')
          .filter(Boolean)
      )];
    },
    u_IsMultipleOption(option) {
      return option && option.allowMultiple !== false;
    },
    u_RebuildCurrentSelectedValues() {
      this.current_selected_values = this.filters_options
        .flatMap(option => option.values
          .filter(value => value.selected)
          .map(value => ({
            key: `${option.id}:${value.id}`,
            filter_id: option.id,
            value_id: value.id
          }))
        );
    },
    u_SetDrawerInteractivity(is_open) {
      if (!this.drawer_element) return;

      if (is_open) {
        this.drawer_element.setAttribute('aria-hidden', 'false');
        this.drawer_element.removeAttribute('inert');
        return;
      }

      this.drawer_element.setAttribute('aria-hidden', 'true');
      this.drawer_element.setAttribute('inert', '');
    },
    u_ResolveDrawerFocusTarget(preferred_target) {
      if (preferred_target && preferred_target.isConnected && typeof preferred_target.focus === 'function') {
        return preferred_target;
      }

      if (this.drawer_opener_element && this.drawer_opener_element.isConnected && typeof this.drawer_opener_element.focus === 'function') {
        return this.drawer_opener_element;
      }

      const fallback = this.$el.querySelector('.boost-pfs-main-filter-button button, .pfs-collection-grid-filter-btn');
      if (fallback && fallback.isConnected && typeof fallback.focus === 'function') {
        return fallback;
      }

      return null;
    },
    u_MoveFocusOutsideDrawer(preferred_target = null) {
      if (!this.drawer_element) return;

      const active_element = document.activeElement;
      const is_focus_inside_drawer = active_element && this.drawer_element.contains(active_element);
      if (!is_focus_inside_drawer) return;

      const focus_target = this.u_ResolveDrawerFocusTarget(preferred_target);
      if (focus_target) {
        focus_target.focus();
        return;
      }

      if (typeof active_element.blur === 'function') {
        active_element.blur();
      }
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.InitEventListeners();
      this.u_SyncPaginationFromDataset();
      this.InitInfiniteScroll();
      if (this.u_IsRandomOrderEnabled()) {
        this.u_ShuffleCollectionGrid();
      }
    },
    u_IsRandomOrderEnabled() {
      return u_IsSaleRandomOrderEnabled(this.$el);
    },
    u_IsNewFiltersEnabled() {
      return this.$el.dataset.svUseNewCollectionFilters === 'true';
    },
    u_ShuffleCollectionGrid($grid) {
      const $target_grid = $grid || this.$el.querySelector('.grid--collection');
      u_ShuffleGridProducts($target_grid);
    },
    u_ScrollToCollectionGrid() {
      const $scroll_target = this.$el.querySelector('[data-scroll-to]') || document.getElementById('CollectionAjaxResult');
      if (!$scroll_target) return;

      let scroll_to = $scroll_target.getBoundingClientRect().top + window.pageYOffset;
      let offset = -240;
      if (window.matchMedia('(max-width: 768px)').matches) {
        offset = -150;
      }
      scroll_to += offset;

      const $header = document.querySelector('.site-header');
      if ($header && typeof theme !== 'undefined' && theme.config && theme.config.stickyHeader) {
        scroll_to -= $header.offsetHeight;
      }

      window.scrollTo({ top: scroll_to, behavior: 'smooth' });
    },
    u_BuildCollectionSectionUrl(page) {
      const section_id = this.$el.dataset.sectionId || 'collection-template';
      let url = `/collections/${this.collection_handle}?section_id=${section_id}&page=${page}`;
      this.selected_values.forEach(value => {
        if (!value.param_name) return;
        url += `&${value.param_name}=${value.value_url}`;
      });
      const sort_by = new URLSearchParams(window.location.search).get('sort_by');
      if (sort_by) {
        url += `&sort_by=${encodeURIComponent(sort_by)}`;
      }
      return url;
    },
    u_SyncPaginationFromDataset($section) {
      const $root = $section || this.$el;
      this.currentPage = parseInt($root.dataset.currentPage, 10) || 1;
      this.totalPages = parseInt($root.dataset.totalPages, 10) || 1;
      this.flags.hasMore = this.currentPage < this.totalPages;
      this.$el.dataset.currentPage = String(this.currentPage);
      this.$el.dataset.totalPages = String(this.totalPages);
    },
    u_TeardownInfiniteScroll() {
      if (this.infiniteScrollObserver) {
        this.infiniteScrollObserver.disconnect();
        this.infiniteScrollObserver = null;
      }
      this.$el.classList.remove('collection-infinite-scroll');
    },
    InitInfiniteScroll() {
      this.u_TeardownInfiniteScroll();
      this.u_SyncPaginationFromDataset();

      if (this.totalPages <= 1) return;

      this.$el.classList.add('collection-infinite-scroll');

      const $sentinel = this.$el.querySelector('.collection-infinite-scroll-sentinel');
      if (!$sentinel) return;

      this.infiniteScrollObserver = ObserveIntersection($sentinel, { rootMargin: '200px 0px' }, (entries) => {
        if (!entries || !entries[0] || !entries[0].isIntersecting) return;
        if (!this.flags.hasMore || this.flags.loadingMore) return;
        this.loadNextPage();
      });
    },
    u_LoadNextIfVisible() {
      if (!this.flags.hasMore || this.flags.loadingMore || this.flags.loadError) return;

      const $sentinel = this.$el.querySelector('.collection-infinite-scroll-sentinel');
      if (!$sentinel) return;

      const rect = $sentinel.getBoundingClientRect();
      const root_margin = 200;
      const in_view = rect.top <= window.innerHeight + root_margin && rect.bottom >= -root_margin;

      if (in_view) this.loadNextPage();
    },
    retryLoadNextPage() {
      this.flags.loadError = false;
      this.loadNextPage();
    },
    async loadNextPage() {
      if (this.flags.loadingMore || !this.flags.hasMore) return;

      this.flags.loadingMore = true;
      this.flags.loadError = false;

      try {
        const next_page = this.currentPage + 1;
        const response = await fetch(this.u_BuildCollectionSectionUrl(next_page));
        if (!response.ok) throw new Error('Collection page fetch failed');

        const $doc = ConvertStringToHTML(await response.text());
        const $new_section = $doc.querySelector('#CollectionSection') || $doc.querySelector('[data-section-type="collection-template"]');
        if (!$new_section) throw new Error('Collection section not found');

        const $grid = this.$el.querySelector('.grid--collection');
        const $new_grid = $new_section.querySelector('.grid--collection');
        if ($grid && $new_grid) {
          const $new_items = [...$new_grid.querySelectorAll('.grid-product')];

          if (this.u_IsRandomOrderEnabled()) {
            u_ShuffleGridProducts($grid, $new_items);
          } else {
            $new_items.forEach($child => $grid.appendChild($child));
          }

          if (typeof Alpine !== 'undefined' && typeof Alpine.initTree === 'function') {
            Alpine.initTree($grid);
          }
        }

        const $modal_container = this.$el.querySelector('.boost-pfs-quick-shop-modal-container');
        const $new_modals = $new_section.querySelector('.boost-pfs-quick-shop-modal-container');
        if ($modal_container && $new_modals) {
          [...$new_modals.children].forEach($child => {
            $modal_container.appendChild($child);
          });
        }

        const $pagination = this.$el.querySelector('.boost-pfs-filter-bottom-pagination');
        const $new_pagination = $new_section.querySelector('.boost-pfs-filter-bottom-pagination');
        if ($pagination && $new_pagination) {
          $pagination.innerHTML = $new_pagination.innerHTML;
        }

        this.$el.dataset.currentPage = $new_section.dataset.currentPage;
        this.$el.dataset.totalPages = $new_section.dataset.totalPages;
        this.u_SyncPaginationFromDataset(this.$el);
        this.UpdateUrl();

        if (!this.flags.hasMore && this.infiniteScrollObserver) {
          this.infiniteScrollObserver.disconnect();
          this.infiniteScrollObserver = null;
        }
      } catch (err) {
        this.flags.loadError = true;
      } finally {
        this.flags.loadingMore = false;
        requestAnimationFrame(() => {
          this.u_LoadNextIfVisible();
        });
      }
    },
    InitSelf() {
      this.collection_handle = this.$el.dataset.collectionHandle;
      if (!this.u_IsNewFiltersEnabled()) return;

      let $drawer = this.$el.querySelector('#collection-filter-drawer');
      this.drawer_element = $drawer;
      this.filters_drawer = new theme.Drawers('collection-filter-drawer', 'pfs-boost-collection-filter', true);

      // on load, initialize selected values from url
      let url_params = new URLSearchParams(window.location.search);
      let options = [...this.filters_options];
      options.forEach(option => {
        option.values.forEach(value => {
          value.selected = false;
        });

        const selected_values = this.u_NormalizeQueryValues(url_params.getAll(option.id));
        if (!selected_values.length) return;

        option.values.forEach(value => {
          value.selected = selected_values.includes(value.value_url);
        });

        if (!this.u_IsMultipleOption(option)) {
          let first_selected_found = false;
          option.values.forEach(value => {
            if (!value.selected) return;
            if (!first_selected_found) {
              first_selected_found = true;
              return;
            }
            value.selected = false;
          });
        }
      });

      this.filters_options = [...options];
      this.u_RebuildCurrentSelectedValues();

      this.u_SetDrawerInteractivity(false);

      if (window.MutationObserver && this.drawer_element) {
        this.drawer_focus_observer = new MutationObserver(() => {
          if (this.drawer_element.getAttribute('aria-hidden') !== 'true') return;
          this.u_MoveFocusOutsideDrawer();
          this.drawer_element.setAttribute('inert', '');
        });

        this.drawer_focus_observer.observe(this.drawer_element, {
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      }
    },
    InitWatchers() {
      if (!this.u_IsNewFiltersEnabled()) return;

      const syncFilters = () => {
        const keys = this.filters_options
          .flatMap(option => option.values.filter(value => value.selected).map(value => `${option.id}:${value.id}`))
          .sort()
          .join(',');

        if (keys !== this.selectedKeysSnapshot) {
          this.selectedKeysSnapshot = keys;
          this.FetchAndUpdateProducts();
          this.UpdateUrl();
        }
      };

      this.filterSync = syncFilters;
      this.filterApplyDebounced = Alpine.debounce(syncFilters, 300);

      this.$watch('filters_options', () => {
        this.filterApplyDebounced();
      });
    },
    InitEventListeners() {
      if (!this.u_IsNewFiltersEnabled()) return;

      // on drawer close, close all filter options
      $('body').on('drawerClose.collection-filter-drawer', () => {
        this.u_MoveFocusOutsideDrawer();
        this.filters_options.forEach(option => {
          option.open = false;
        });

        document.body.classList.remove('boost-pfs-filter-tree-open-body');
        this.u_SetDrawerInteractivity(false);
      });

      $('.PageOverlay').on('click.collection-filter-drawer', () => {
        if (!this.filters_drawer || !this.filters_drawer.isOpen) return;
        this.filters_drawer.close();
      });
    },
    e_OpenFiltersDrawer(filter_id, e) {
      const opener = e && e.currentTarget ? e.currentTarget : document.activeElement;
      this.drawer_opener_element = opener && opener.isConnected ? opener : null;

      this.filters_options.forEach(option => {
        option.open = option.id == filter_id || filter_id == 'all';
      });

      this.u_SetDrawerInteractivity(true);
      document.body.classList.add('boost-pfs-filter-tree-open-body');
      this.filters_drawer.open(e);
    },
    e_OpenFilterOption(filter_id) {
      let option = this.filters_options.find(option => option.id == filter_id);
      option.open = !option.open;
    },
    e_ToggleFilterValue(filter_id, value_id) {
      const option = this.filters_options.find(o => o.id === filter_id);
      if (!option) return;

      const value = option.values.find(v => v.id === value_id);
      if (!value) return;

      const is_multiple = this.u_IsMultipleOption(option);
      const next_selected = !value.selected;

      if (!is_multiple && next_selected) {
        option.values.forEach(option_value => {
          option_value.selected = option_value.id === value_id;
        });
      } else {
        value.selected = next_selected;
      }

      this.flags.scrollToGridOnFilter = true;
      this.u_RebuildCurrentSelectedValues();
    },
    e_ClearAllFilters() {
      this.filters_options.forEach(option => {
        option.values.forEach(value => {
          value.selected = false;
        });
      });

      this.flags.scrollToGridOnFilter = true;
      this.u_RebuildCurrentSelectedValues();
    },
    async FetchAndUpdateProducts() {
      this.flags.loadError = false;

      try {
        const response = await fetch(this.u_BuildCollectionSectionUrl(1));
        if (!response.ok) throw new Error('Collection fetch failed');

        const $new_response = ConvertStringToHTML(await response.text());
        const $new_section = $new_response.querySelector('#CollectionSection') || $new_response.querySelector('[data-section-type="collection-template"]');

        const $counts = this.$el.querySelector('.boost-pfs-filter-total-product');
        const $new_counts = $new_response.querySelector('.boost-pfs-filter-total-product');
        if ($counts && $new_counts) {
          $counts.replaceWith($new_counts);
        }

        const $grid_collection = this.$el.querySelector('.grid--collection');
        const $new_grid_collection = $new_response.querySelector('.grid--collection');
        if ($grid_collection && $new_grid_collection) {
          $grid_collection.replaceWith($new_grid_collection);
          if (this.u_IsRandomOrderEnabled()) {
            this.u_ShuffleCollectionGrid($new_grid_collection);
          }
        }

        const $pagination = this.$el.querySelector('.boost-pfs-filter-bottom-pagination');
        const $new_pagination = $new_section && $new_section.querySelector('.boost-pfs-filter-bottom-pagination');
        if ($pagination && $new_pagination) {
          $pagination.innerHTML = $new_pagination.innerHTML;
        }

        const $modal_container = this.$el.querySelector('.boost-pfs-quick-shop-modal-container');
        const $new_modals = $new_section && $new_section.querySelector('.boost-pfs-quick-shop-modal-container');
        if ($modal_container && $new_modals) {
          $modal_container.innerHTML = $new_modals.innerHTML;
        }

        if ($new_section) {
          this.$el.dataset.currentPage = $new_section.dataset.currentPage;
          this.$el.dataset.totalPages = $new_section.dataset.totalPages;
        }

        this.u_SyncPaginationFromDataset();
        this.InitInfiniteScroll();
        this.UpdateUrl();

        if (this.flags.scrollToGridOnFilter) {
          this.flags.scrollToGridOnFilter = false;
          requestAnimationFrame(() => {
            this.u_ScrollToCollectionGrid();
          });
        }
      } catch (err) {
        this.flags.loadError = true;
        this.flags.scrollToGridOnFilter = false;
      }
    },
    UpdateUrl() {
      // keep any existing params
      let url_params = new URLSearchParams(window.location.search);

      // remove all existing filter params that this component owns
      this.filters_options.forEach(option => {
        url_params.delete(option.id);
      });

      // append canonical selected state for current filters
      const seen = new Set();
      this.selected_values.forEach(value => {
        const option_id = typeof value.option_id === 'string' ? value.option_id.trim() : '';
        const value_url = typeof value.value_url === 'string' ? value.value_url.trim() : '';
        if (!option_id || !value_url) return;

        const unique_key = `${option_id}::${value_url}`;
        if (seen.has(unique_key)) return;

        seen.add(unique_key);
        url_params.append(option_id, value_url);
      });

      if (this.currentPage > 1) {
        url_params.set('page', String(this.currentPage));
      } else {
        url_params.delete('page');
      }

      const query = url_params.toString();
      const next_url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
      window.history.replaceState({}, '', next_url);
    }
  }));
});

if (!customElements.get('media-holder')) {
  customElements.define('media-holder', class extends HTMLElement {
    constructor() {
      super();
      this.insertAdjacentHTML('beforeend', this.querySelector('template').innerHTML);
    }

    connectedCallback() {
      // this.insertAdjacentHTML('beforeend', this.querySelector('template').innerHTML);
    }
  });
}

if (!customElements.get('linked-product-templates')) {
  customElements.define('linked-product-templates', class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.LoadProducts();
    }

    LoadProducts() {
      this.querySelectorAll('template').forEach(($template) => {
        this.insertAdjacentHTML('beforeend', $template.innerHTML);
      });
    }
  });
}